import * as React from 'react';
import { Component, deps, inject, observer } from '../../lib/component';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Loading } from './loading';
import {HookdDefinition} from '../hookd-definition';
import {classes, style} from 'typestyle';
import {mediaDesktop, mediaMobileOnly} from '../../theme/media';
import {constantDrawerWidth} from '../../theme/constant';
import {zContentLoader, zFlash} from '../../theme/z';
import {colorBrand, colorWhite} from '../../theme/color';
import {centerCenter, vertical} from 'csstips';

export interface LoadingOverlayProps {
  loading: boolean;
}

@inject(deps) @observer
export class LoadingOverlay extends Component<LoadingOverlayProps> {
  render() {
    const { showMenuDrawer } = this.props.model.ui;
    const className = classes(
      LoadingOverlay.styles.container,
      showMenuDrawer && LoadingOverlay.styles.containerShunted
    );

    return (
      <ReactCSSTransitionGroup
        transitionName={LoadingOverlay.styles}
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}>
        {this.props.loading && (
          <div key="container" className={className}>
            <Loading light={true} />
            <HookdDefinition light={true} />
          </div>
        )}
      </ReactCSSTransitionGroup>
    )
  }

  componentWillReceiveProps(props: LoadingOverlayProps) { this.changePageScrolling(props.loading); }
  componentWillMount() { this.changePageScrolling(this.props.loading); }

  changePageScrolling = (prevent: boolean) => {
    this.props.controller.ui.setScrollBehaviour(prevent);
  };

  static styles = {
    container: style(
      {
        ...vertical,
        ...centerCenter,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: zContentLoader,
        background: colorBrand.toString(),
        $nest: {
          '& h3': {
            color: colorWhite.toString(),
          },
          '& > div:last-child': {
            position: 'absolute',
            bottom: '60px',
            left: '60px'
          }
        }
      },
      mediaMobileOnly({
        $nest: {
          '& > div:last-child': {
            bottom: '10px',
            left: '10px',
            maxWidth: `calc(100vw - 20px)`,
            transform: 'scale(0.7)',
            transformOrigin: 'bottom left',
          }
        }
      })
    ),
    containerShunted: style(
      mediaDesktop({
        right: constantDrawerWidth
      })
    ),

    enter: style({
      opacity: 0.01,
    }),
    enterActive: style({
      opacity: 1,
      transition: 'opacity 500ms ease-in'
    }),
    leave: style({
      opacity: 1,
    }),
    leaveActive: style({
      opacity: 0.01,
      transition: 'opacity 300ms ease-in'
    }),
    appear: style({}),
    appearActive: style({})
  }
}